import request from '../../utils/request';

export function getTeamList(params) {
  return request(`/teams`, {
    method: 'GET',
    params,
  });
}

export function addTeam(params) {
  return request(`/teams`, {
    method: 'POST',
    data: params,
  });
}

export function jionTeam(params) {
  return request(`/teams/join`, {
    method: 'POST',
    data: params,
  });
}

export function getTeamDetail(params) {
  return request(`/teams/${params.team_id}`, {
    method: 'GET',
  });
}

export function getTeamMember({ team_id }) {
  return request(`/teams/${team_id}/members`, {
    method: 'GET',
  });
}

export function AuditMenmber(params) {
  return request(`user-center/teams/audit`, {
    method: 'POST',
    params,
  });
}

export function getSecurityTeams() {
  return request.get('/security_teams')
}

export function getSecurityTeamDetail(title) {
  return request.get(`/security_teams/${title}`)
}

export function getTeamMembers(title, page) {
  return request.get(`security_teams/${title}/members`, {
    params: {
      page
    }
  })
}

export const getMyTeamMembers = (status) => {
  return request.post('/security_teams/my_team_members', {
    status
  })
}

export const applyTeam = (id, comment) => {
  return request.post('/security_teams/apply', {
    team_id: id,
    apply_comment: comment
  })
}

export const auditTeamApply = (userId, type) => {
  return request.post('/security_teams/members/audit', {
    user_id: userId,
    type
  })
}
